import React from 'react'
import { useAppSelector } from '../../../state/hooks'
import { View, Platform, Linking } from 'react-native'
import { Text } from '../../../components/DesignSystem'

export default function PrivacyPolicyContent() {
	const { privacyPolicy } = useAppSelector(state => state.settings)

	const { loadedData } = useAppSelector(state => state.data)
	const orgName = loadedData[global.org].name
	const isWeb = Platform.OS === 'web'

	const url = loadedData[global.org].webURL
	const cleanUrl = url.replace(/^https?:\/\//, '')

	return (
		<View>
			<Text>
				{`I consent to ${orgName} collecting, using, and disclosing my personal information in accordance with the `}
				{isWeb ? (
					<Text
						style={{ color: 'mediumblue' }}
						onPress={() => {
							window.open('/privacy-policy', '_blank')
						}}
					>
						Privacy Policy
					</Text>
				) : (
					<Text>Privacy Policy</Text>
				)}
				{`. I agree to receive marketing communications, including promotional offers, newsletters, and updates, via email, SMS, or other electronic means. I understand that I can withdraw my consent at any time by clicking "unsubscribe" in emails, replying "STOP" to SMS messages, or contacting ${orgName} at ${privacyPolicy.emailAddress}`}
				. {!isWeb && <Text>{`Visit ${cleanUrl} to view the privacy policy. `}</Text>}
			</Text>
		</View>
	)
}
